import { UpsellCard } from 'src/v2/commonComponents/UpsellCard';
import lightIcon from 'src/images/icons/art-edit-image.svg';
import darkIcon from 'src/images/icons/art-edit-image-dark.svg';
import styles from './EditImageUpsell.module.scss';

export const EditImageUpsell = () => {
  return (
    <div className={styles.upsellCardWrapper}>
      <UpsellCard
        darkIcon={darkIcon}
        lightIcon={lightIcon}
        description="Remove the Preview label and access premium AI models such as GPT Image1, Gemini Imagen 4 Ultra, Flux.1 Kontext, and more."
        dataGTM="Edit-message"
        upgradeTitle="Upgrade to unlock"
        title="Upgrade for full access"
      />
    </div>
  );
};
